import React, { useRef, useState, useEffect } from "react";
import Projects from "./pages/projects/Projects";
import Home from "./pages/home/Home";

import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import AboutUs from "./pages/aboutUs/AboutUs";
import Services from "./pages/services/Services";
import Contact from "./pages/contact/Contact";
import Service from "./pages/services/Service";
import NavbarNew from "./components/NavbarNew";

const Layout = () => {
  const navbarRef = useRef<HTMLDivElement>(null);
  const [navbarHeight, setNavbarHeight] = useState(0);

  useEffect(() => {
    if (navbarRef.current) setNavbarHeight(navbarRef.current.offsetHeight);

    const handleResize = () => {
      if (navbarRef.current) setNavbarHeight(navbarRef.current.offsetHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    // <div className="w-full min-h-screen  ">
    //   <NavbarNew />
    //   {/* <Navbar /> */}
    //   <main>
    //     <Outlet />
    //   </main>
    // </div>
    <div className="w-full min-h-screen">
      <div ref={navbarRef}>
        <NavbarNew />
      </div>
      {/* Pass navbarHeight down via context or props */}
      <Outlet context={{ navbarHeight }} />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/aboutUs",
        element: <AboutUs />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/services/service",
        element: <Service />,
      },
      {
        path: "/projects",
        element: <Projects />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
    ],
  },
]);

function App() {
  return (
    <div className="2xl:px-32 overflow-hidden">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
